import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import toast from 'react-hot-toast';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const EditPage = () => {
  const [loading, setLoading] = useState(true);
  const [SubmitLoading, setSubmitLoading] = useState(true);
  const [editorValue, setEditorValue] = useState('');
  const [showCode, setShowCode] = useState(true);

  const { slug } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: '',
    description: '',
    metaTitle: '',
    metaDescription: '',
    metaKeywords: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleDescriptionChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      description: value,
    }));
  };

  const toggleShowCode = () => {
    setShowCode(!showCode);
  };

  const fetchData = async () => {
    try {
      const { data } = await axiosInstance.get(`/admin/get-page/${slug}`);
      setLoading(false);
      setFormData((prevData) => ({
        ...prevData,
        title:           data.Mpage.title,
        description:     data.Mpage.description, // ✅ fixed (was data.Mpage.title)
        metaTitle:       data.Mpage.metaTitle,
        metaDescription: data.Mpage.metaDescription,
        metaKeywords:    data.Mpage.metaKeywords,
      }));
      setEditorValue(data.Mpage.description); // ✅ load HTML into editor
    } catch (error) {
      console.log(error);
      toast.error('Error fetching page!');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const submitData = async () => {
    setSubmitLoading(false);
    try {
      const admintoken = localStorage.getItem('adminToken');
      if (admintoken) {
        await axiosInstance.put(`/admin/update-page/${slug}`, formData);
        toast.success('Page updated successfully!');
        navigate('/all-page');
      }
    } catch (error) {
      console.error('Error updating page:', error);
      toast.error(error.response?.data?.message || 'Update failed');
    } finally {
      setSubmitLoading(true);
    }
  };

  const SkeletonBlock = ({ height }) => (
    <p className="skeleton" style={{ width: '100%', borderRadius: 5, margin: '0px auto 10px', height }} />
  );

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />

        <div className="py-4">
          <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
              <li className="breadcrumb-item">
                <a href="#">
                  <svg className="icon icon-xxs" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                </a>
              </li>
              <li className="breadcrumb-item"><a href="#">Admin</a></li>
              <li className="breadcrumb-item active" aria-current="page">Edit Page</li>
            </ol>
          </nav>

          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4">Edit Page</h1>
            </div>
            <div>
              <Link to="/all-page" className="btn btn-primary d-inline-flex align-items-center">
                <svg style={{ transform: 'rotate(180deg)' }} className="icon icon-sm" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
                Go back
              </Link>
            </div>
          </div>
        </div>

        <div id="add-blog-form">
          <div className="row">

            {/* Left Column */}
            <div className="col-md-8 mb-4">
              <div className="card border-0 shadow components-section">
                <div className="card-body">

                  {loading ? (
                    <div className="row mb-4">
                      <div className="col-lg-12">
                        <SkeletonBlock height={70} />
                        <SkeletonBlock height={70} />
                        <SkeletonBlock height={70} />
                        <SkeletonBlock height={70} />
                        <SkeletonBlock height={135} />
                      </div>
                    </div>
                  ) : (
                    <div className="row mb-4">
                      <div className="col-lg-12 col-sm-12">
                        <div className="row">

                          {/* Page Title */}
                          <div className="col-md-12">
                            <div className="mb-4">
                              <label htmlFor="title">Page Name</label>
                              <input
                                type="text"
                                defaultValue={formData.title}
                                className="form-control"
                                id="title"
                                name="title"
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          {/* Description */}
                          <div className="col-md-12">
                            <div className="mb-4">
                              <label htmlFor="description" className="d-flex align-items-center justify-content-between">
                                Description
                                <button onClick={toggleShowCode} className="btn btn-secondary btn-sm" type="button">
                                  {showCode ? 'Show Editor' : 'Show Code'}
                                </button>
                              </label>

                              {showCode ? (
                                // ✅ Fixed: use e.target.value for native textarea
                                <textarea
                                  className="form-control"
                                  value={editorValue}
                                  onChange={(e) => {
                                    setEditorValue(e.target.value);
                                    handleDescriptionChange(e.target.value);
                                  }}
                                  rows={10}
                                  cols={80}
                                  name="description"
                                />
                              ) : (
                                // ✅ ReactQuill gives plain value directly (no .target.value)
                                <ReactQuill
                                  value={editorValue}
                                  onChange={(value) => {
                                    setEditorValue(value);
                                    handleDescriptionChange(value);
                                  }}
                                  modules={{
                                    toolbar: [
                                      [{ header: '1' }, { header: '2' }],
                                      [{ size: [] }],
                                      ['bold', 'italic', 'underline'],
                                      [{ list: 'ordered' }, { list: 'bullet' }],
                                      ['link'],
                                      ['clean'],
                                    ],
                                  }}
                                  formats={['header', 'size', 'bold', 'italic', 'underline', 'list', 'bullet', 'link']}
                                  bounds=".app"
                                />
                              )}
                            </div>
                          </div>

                          {/* Meta Fields */}
                          <div className="col-md-12">
                            <div className="mb-4">
                              <label htmlFor="metaTitle">Meta Title</label>
                              <input
                                type="text"
                                className="form-control"
                                id="metaTitle"
                                value={formData.metaTitle}
                                name="metaTitle"
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="mb-4">
                              <label htmlFor="metaDescription">Meta Description</label>
                              <textarea
                                className="form-control"
                                value={formData.metaDescription}
                                rows="4"
                                name="metaDescription"
                                id="metaDescription"
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="mb-4">
                              <label htmlFor="metaKeywords">Meta Keywords</label>
                              <textarea
                                className="form-control"
                                rows="4"
                                value={formData.metaKeywords}
                                name="metaKeywords"
                                id="metaKeywords"
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-md-4 mb-4">
              <div className="card border-0 shadow components-section">
                <div className="card-body">

                  {loading ? (
                    <>
                      <SkeletonBlock height={50} />
                      <SkeletonBlock height={250} />
                      <SkeletonBlock height={40} />
                    </>
                  ) : null}

                  <div className="col-12 mt-3">
                    {SubmitLoading ? (
                      <button className="btn btn-secondary" type="button" onClick={submitData}>
                        Update Page
                      </button>
                    ) : (
                      <button className="btn btn-secondary btn-sm" type="button" disabled>
                        <span className="ms-1">Loading...</span>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                      </button>
                    )}
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>

      </main>
    </>
  );
};

export default EditPage;